import { Theme } from '@mui/material'
import Box from '@mui/material/Box'
import React from 'react'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { Subscription } from '../../Profile/types'
import { UnitCancel } from '../../Units/reducer'
import {
  getActiveCancellationRecord,
  getCancellationOperatorStatus,
} from '../../Units/cancellationStatus'

export interface Column {
  id: string
  label: string
  minWidth?: number
  maxWidth?: number
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify'
}

const columns: readonly Column[] = [
  { id: 'name', label: 'Unit Size / Number', minWidth: 170 },
  { id: 'startDate', label: 'Start Date', minWidth: 120 },
  {
    id: 'status',
    label: 'Status',
    minWidth: 150,
  },
  {
    id: 'amount',
    label: 'Monthly Amount',
    minWidth: 140,
    align: 'right',
  },
  {
    id: 'cancel',
    label: '',
    minWidth: 210,
    align: 'center',
  },
]

interface Props {
  subscriptions: Subscription[]
  onIsConfirmOpen: (subscription: Subscription) => void
  unitsCancel: UnitCancel[]
}
export const PortalSubscriptionsComponent: React.FC<Props> = ({
  subscriptions,
  onIsConfirmOpen,
  unitsCancel,
}) => {
  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <Box
        sx={{
          py: 1,
          px: 2,
          bgcolor: (theme: Theme) => theme.palette.info.dark,
        }}
      >
        <Typography variant="h6">Subscriptions</Typography>
      </Box>
      <TableContainer sx={{ minHeight: 274, maxHeight: 274 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{
                    minWidth: column.minWidth,
                    maxWidth: column.maxWidth,
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {subscriptions
              .filter((s) => s.status !== 'canceled')
              .map((row) => {
                return (
                  <TableRow hover tabIndex={-1} key={row.subscriptionId}>
                    {columns.map((column) => {
                      const value = row[column.id as keyof Subscription] as any
                      const isStatus = column.id === 'status'
                      const isCurrency = column.id === 'amount'
                      const isCancel = column.id === 'cancel'

                      const cancellation = getActiveCancellationRecord(
                        row.subscriptionId,
                        unitsCancel
                      )
                      const cancellationStatus =
                        getCancellationOperatorStatus(cancellation)
                      const isStatusInCancelMode =
                        isStatus && cancellationStatus != null
                      const isHideCancelBtn = isCancel && cancellationStatus != null

                      if (isCancel) {
                        return (
                          <TableCell
                            key={column.id}
                            style={{
                              minWidth: column.minWidth,
                              maxWidth: column.maxWidth,
                            }}
                            align={column.align}
                          >
                            <Button
                              variant="contained"
                              color="info"
                              size="small"
                              onClick={() => onIsConfirmOpen(row)}
                              sx={{
                                minWidth: column.minWidth,
                                visibility: isHideCancelBtn
                                  ? 'hidden'
                                  : 'visible',
                              }}
                            >
                              Cancel Subscription
                            </Button>
                          </TableCell>
                        )
                      }
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {`${isCurrency ? '$' : ''}${
                            isStatusInCancelMode ? cancellationStatus : value
                          }`}
                        </TableCell>
                      )
                    })}
                  </TableRow>
                )
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}
